module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7CKnc"))).then(() => parcelRequire('d0iPb'));